/* import __COLOCATED_TEMPLATE__ from './checkbox-inline-edit.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class CheckboxInlineEditComponent extends Component {
	@action
	toggleValue(event) {
		const newValue = event.target.checked;
		this.args.model[this.args.field] = newValue;
		this.args.model.save();
	}
}
